
/*
                <Route exact path="/rispondi-sondaggio" 
                element={<RispondiSondaggio 
                comune={comune} 
                partecipante={partecipante} />} />
*/

import { Card, Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ModalConferma from "../../Utilities/ModalConferma";
import ModalConfermaConsensoPrivacy from "../../Utilities/ModalConfermaConsensoPrivacy";

import SondaggiService from "../../../services/SondaggiService";
import { Navigate } from 'react-router-dom';
import { FiAlertTriangle } from 'react-icons/fi'
import SondaggioPartecipanteService from "../../../services/SondaggioPartecipanteService";
import sondaggioCompletato from '../../../immagini/sondaggi/sondaggioCompletato2.jpg'
import PaginaGrazie from "./Risposte/PaginaGrazie";


export default function RispondiSondaggio(props) {

    const [sondaggio, setSondaggio] = useState(null);
    const [sezioneCorrente, setSezioneCorrente] = useState(0);
    const [domandeCorrenti, setDomandeCorrenti] = useState([]);

    const [mostraModalAbbandona, setMostraModalAbbandona] = useState(false);
    const [mostraModalInviaSondaggio, setMostraModalInviaSondaggio] = useState(false);


    /*
    {
  73: 117,                  // domanda singola → opzione id selezionata
  76: [119, 121],           // domanda multipla → array di opzioni selezionate
  ...
}
La chiave è domanda.domId

Il valore dipende dal tipo:

number per singola

array di number per multipla
    */
    const [risposte, setRisposte] = useState({});
    const [email, setEmail] = useState("");
    const [completato, setCompletato] = useState(false);
    const location = useLocation();

    const [domandeInErrore, setDomandeInErrore] = useState([]);
    const [mostraErroreObbligatorie, setMostraErroreObbligatorie] = useState(false);
    const [cronologiaSezioni, setCronologiaSezioni] = useState([]);

    //nuovo flag consenso privacy
    const [consensoPrivacy, setConsensoPrivacy] = useState(false)

    function isValidEmail() {
        return /\S+@\S+\.\S+/.test(email);
    }

    const navigate = useNavigate();
    const goToLogin = () => {
        navigate("/login", { state: { prevPath: location.pathname } })
    }

    useEffect(() => {
        const sonId = location.state?.sondaggio?.sonId;
        if (sonId) {
            SondaggiService.getSondaggioById(sonId)
                .then(response => {



                    let sondaggio = response.data;

                    // Ordina le sezioni per posizione
                    const sezioniOrdinate = [...sondaggio.sezioni].sort(
                        (a, b) => a.sezPosizione - b.sezPosizione
                    );

                    // Salva il sondaggio con le sezioni ordinate
                    sondaggio.sezioni = sezioniOrdinate;
                    setSondaggio(sondaggio);

                    if (sezioniOrdinate.length > 0) {
                        const primaSezione = sezioniOrdinate[0];
                        const domandeOrdinate = [...primaSezione.domande].sort(
                            (a, b) => a.domNumPosizione - b.domNumPosizione
                        );
                        setDomandeCorrenti(domandeOrdinate);
                    }

                    if (props.partecipante?.parId && sondaggio?.sonId) {
                        SondaggioPartecipanteService.getBySondaggioAndPartecipante(sondaggio.sonId, props.partecipante.parId)
                            .then((res) => {
                                if (res.data) {
                                    // ⚠️ Se ha già risposto, reindirizza
                                    navigate("/sondaggio-gia-completato", { replace: true });
                                }
                            })
                            .catch((err) => {
                                console.error("Errore nel controllo partecipazione:", err);
                            });
                    }
                })
                .catch(error => {
                    console.error("Errore nel recupero del sondaggio:", error);
                });
        }
    }, []);


    // useEffect per lo SCROLL
    useEffect(() => {
        // Scrolla la finestra del browser all'inizio (coordinate 0, 0)
        window.scrollTo(0, 0);

    }, [sezioneCorrente]); // <-- Esegui questo effetto ogni volta che 'sezioneCorrente' cambia

    const sezioneContieneOpzioneTermina = () => {
        const domandeRisposte = domandeCorrenti
            .filter(domanda => risposte[domanda.domId])
            .reverse(); // Considera l'ultima risposta data

        for (let domanda of domandeRisposte) {
            const risposta = risposte[domanda.domId];

            if (typeof risposta === "number") {
                const opzione = domanda.opzioniRisposte.find(o => o.opzRisId === risposta);
                if (opzione?.opzRisFlTermina) {
                    return true;
                }
            }

            if (Array.isArray(risposta)) {
                const opzioniOrdinate = [...domanda.opzioniRisposte].sort((a, b) => a.opzRisPosizione - b.opzRisPosizione);
                for (let i = opzioniOrdinate.length - 1; i >= 0; i--) {
                    const opz = opzioniOrdinate[i];
                    if (risposta.includes(opz.opzRisId) && opz.opzRisFlTermina) {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    const trovaUltimaNavigazioneDallaSezione = (sezione) => {
        const domandeRisposte = sezione.domande
            .filter(domanda => risposte[domanda.domId])
            .reverse(); // Partiamo dall'ultima domanda

        for (let domanda of domandeRisposte) {
            const risposta = risposte[domanda.domId];

            if (typeof risposta === "number") {
                const opzione = domanda.opzioniRisposte.find(o => o.opzRisId === risposta);
                if (opzione?.opzRisFlTermina) return { termina: true };
                if (opzione?.opzRisSezSuccessiva) return { sezioneSuccessiva: opzione.opzRisSezSuccessiva };
            }

            if (Array.isArray(risposta)) {
                const opzioniOrdinate = [...domanda.opzioniRisposte].sort((a, b) => a.opzRisPosizione - b.opzRisPosizione);
                for (let i = opzioniOrdinate.length - 1; i >= 0; i--) {
                    const opz = opzioniOrdinate[i];
                    if (risposta.includes(opz.opzRisId)) {
                        if (opz.opzRisFlTermina) return { termina: true };
                        if (opz.opzRisSezSuccessiva) return { sezioneSuccessiva: opz.opzRisSezSuccessiva };
                    }
                }
            }
        }

        return null;
    };



    const trovaSezioneCondizionata = (sezione) => {
        // Trova tutte le domande della sezione a cui l'utente ha risposto
        const domandeRisposte = sezione.domande
            .filter(domanda => risposte[domanda.domId])
            .reverse(); // Inverti l'ordine per iniziare dall'ultima risposta

        for (let domanda of domandeRisposte) {
            const risposta = risposte[domanda.domId];

            if (typeof risposta === "number") {
                const opzione = domanda.opzioniRisposte.find(o => o.opzRisId === risposta);
                if (opzione?.opzRisSezSuccessiva) {
                    return opzione.opzRisSezSuccessiva;
                }
            }

            if (Array.isArray(risposta)) {
                // Considera solo l'ultima opzione selezionata in ordine di posizione
                const opzioniOrdinate = [...domanda.opzioniRisposte].sort((a, b) => a.opzRisPosizione - b.opzRisPosizione);
                for (let i = opzioniOrdinate.length - 1; i >= 0; i--) {
                    const opz = opzioniOrdinate[i];
                    if (risposta.includes(opz.opzRisId) && opz.opzRisSezSuccessiva) {
                        return opz.opzRisSezSuccessiva;
                    }
                }
            }
        }

        return null;
    };



    const handleInvia = () => {
        const sezione = sondaggio.sezioni[sezioneCorrente];
        if (!validaSezione(sezione)) {
            return;
        }

        const navigazione = trovaUltimaNavigazioneDallaSezione(sezione);

        if (navigazione?.termina) {
            setMostraModalInviaSondaggio(true);
            return;
        }

        if (navigazione?.sezioneSuccessiva) {
            const nuovaSezione = sondaggio.sezioni.find(
                (s) => s.sezId === navigazione.sezioneSuccessiva
            );
            if (nuovaSezione) {
                const domandeOrdinate = [...nuovaSezione.domande].sort(
                    (a, b) => a.domNumPosizione - b.domNumPosizione
                );

                // ✅ Salva sezione corrente nella cronologia
                setCronologiaSezioni(prev => [...prev, sezioneCorrente]);

                setSezioneCorrente(sondaggio.sezioni.indexOf(nuovaSezione));
                setDomandeCorrenti(domandeOrdinate);
                return;
            }
        }


        // Nessuna condizione: passa alla sezione successiva in ordine
        const prossimaSezione = sezioneCorrente + 1;
        if (sondaggio.sezioni && prossimaSezione < sondaggio.sezioni.length) {
            const nuovaSezione = sondaggio.sezioni[prossimaSezione];
            const domandeOrdinate = [...nuovaSezione.domande].sort(
                (a, b) => a.domNumPosizione - b.domNumPosizione
            );
            setCronologiaSezioni(prev => [...prev, sezioneCorrente]);
            setSezioneCorrente(prossimaSezione);
            setDomandeCorrenti(domandeOrdinate);

        } else {
            setMostraModalInviaSondaggio(true);
        }
    };





    const handleSingola = (domandaId, opzioneId) => {
        setRisposte(prev => {
            if (prev[domandaId] === opzioneId) {
                // Se la stessa opzione è già selezionata, deseleziona
                const updated = { ...prev };
                delete updated[domandaId];
                return updated;
            } else {
                // Altrimenti, seleziona normalmente
                return { ...prev, [domandaId]: opzioneId };
            }
        });
    };


    const validaSezione = (sezione) => {
        const domandeObbligatorieNonRisposte = [];
        for (let domanda of sezione.domande) {
            const risposta = risposte[domanda.domId];

            if (domanda.domObbligatoria) {
                if (domanda.tipoDomanda.tipDomSingola && !risposta) {
                    domandeObbligatorieNonRisposte.push(domanda.domId);
                }

                if (domanda.tipoDomanda.tipDomMultipla) {
                    if (!Array.isArray(risposta) || risposta.length < domanda.tipoDomanda.tipDomMinRisposte) {
                        domandeObbligatorieNonRisposte.push(domanda.domId);
                    }
                }
            }
        }
        if (domandeObbligatorieNonRisposte.length > 0) {
            setDomandeInErrore(domandeObbligatorieNonRisposte);
            setMostraErroreObbligatorie(true);

            // Nasconde il messaggio dopo 3 secondi
            setTimeout(() => {
                setMostraErroreObbligatorie(false);
                setDomandeInErrore([]);
            }, 3000);

            return false;
        }
        return true;
    };

    const handleIndietro = () => {
        if (cronologiaSezioni.length > 0) {
            const ultima = cronologiaSezioni[cronologiaSezioni.length - 1];

            setCronologiaSezioni(prev => prev.slice(0, -1)); // Rimuovi l'ultimo

            const nuovaSezione = sondaggio.sezioni[ultima];
            const domandeOrdinate = [...nuovaSezione.domande].sort(
                (a, b) => a.domNumPosizione - b.domNumPosizione
            );
            setSezioneCorrente(ultima);
            setDomandeCorrenti(domandeOrdinate);
        }
    };




    const handleMultipla = (domanda, opzioneId, checked) => {
        setRisposte(prev => {
            const attuali = prev[domanda.domId] || [];
            let aggiornate = checked
                ? [...attuali, opzioneId] // Aggiunge se selezionato
                : attuali.filter(id => id !== opzioneId); // Rimuove se deselezionato

            if (
                checked &&
                domanda.tipoDomanda.tipDomMaxRisposte &&
                aggiornate.length > domanda.tipoDomanda.tipDomMaxRisposte
            ) {
                return prev; // Non aggiorna se si supera il massimo consentito
            }

            return { ...prev, [domanda.domId]: aggiornate };
        });
    };


    /*
    Payload corretto: 
    {
  "sonParDataPartecipazione": "2025-03-31T12:00:00.000Z",
  "sonParPunteggioTotale": 28,
  "parId": 42,
  "sonId": 5,
  "risposte": [
    {
      "risTesto": "Risposta aperta test",
      "domandaId": 101,
      "opzioneRispostaId": 201
    },
    {
      "risTesto": null,
      "domandaId": 102,
      "opzioneRispostaId": 202
    }
  ]
}

    */

    const buildSondaggioPartecipantePayload = () => {
        const risposteList = [];
        let punteggioTotaleCalcolato = 0; // Inizializza il punteggio a 0

        // Crea una mappa per un accesso più rapido alle domande e opzioni
        const domandeMap = new Map();
        sondaggio.sezioni.forEach(sezione => {
            sezione.domande.forEach(domanda => {
                const opzioniMap = new Map();
                domanda.opzioniRisposte.forEach(opzione => {
                    opzioniMap.set(opzione.opzRisId, opzione);
                });
                domandeMap.set(domanda.domId, { ...domanda, opzioniMap }); // Salva la domanda con la mappa delle sue opzioni
            });
        });



        // Crea una mappa per un accesso più rapido alle domande e opzioni 
        // Itera sulle risposte date dall'utente (memorizzate nello stato 'risposte')
        for (const domandaIdStr in risposte) {
            const domandaId = parseInt(domandaIdStr, 10); // Le chiavi dell'oggetto sono stringhe
            const rispostaUtente = risposte[domandaId];
            const domandaCorrente = domandeMap.get(domandaId); // Recupera la domanda dalla mappa

            if (!domandaCorrente) {
                console.warn(`Domanda con ID ${domandaId} non trovata nella struttura del sondaggio.`);
                continue; // Salta questa risposta se la domanda non esiste
            }

            // --- Logica di Calcolo Punteggio ---
            if (Array.isArray(rispostaUtente)) {
                // Risposta Multipla: somma i punteggi di tutte le opzioni selezionate
                rispostaUtente.forEach((opzId) => {
                    const opzioneSelezionata = domandaCorrente.opzioniMap.get(opzId);
                    if (opzioneSelezionata && typeof opzioneSelezionata.opzRisPunteggio === 'number') {
                        punteggioTotaleCalcolato += opzioneSelezionata.opzRisPunteggio;
                    }
                    // Aggiungi alla lista per il payload
                    risposteList.push({
                        domandaId: domandaId,
                        opzioneRispostaId: opzId,
                        risTesto: null
                    });
                });
            } else if (typeof rispostaUtente === 'number') {
                // Risposta Singola: aggiungi il punteggio dell'opzione selezionata
                const opzioneSelezionata = domandaCorrente.opzioniMap.get(rispostaUtente);
                if (opzioneSelezionata && typeof opzioneSelezionata.opzRisPunteggio === 'number') {
                    punteggioTotaleCalcolato += opzioneSelezionata.opzRisPunteggio;
                }
                // Aggiungi alla lista per il payload
                risposteList.push({
                    domandaId: domandaId,
                    opzioneRispostaId: rispostaUtente,
                    risTesto: null
                });
            }
            // Ignora altri tipi di risposte (es. stringhe per risposte aperte) per il calcolo del punteggio

        } // Fine ciclo for sulle risposte


        // Verifica che partecipante e sondaggio siano validi prima di creare il payload finale
        if (!props.partecipante?.parId || !sondaggio?.sonId) {
            console.error("ID Partecipante o ID Sondaggio mancante!");
            return null; // O gestisci l'errore
        }

        // Costruisci il payload finale
        return {
            sonParDataPartecipazione: new Date().toISOString(),
            sonParPunteggioTotale: punteggioTotaleCalcolato, // Usa il punteggio calcolato
            sonParFlConsensoPrivacy: consensoPrivacy,
            parId: props.partecipante.parId,
            sonId: sondaggio.sonId,
            risposte: risposteList // Usa la lista creata nel ciclo
        };
    };

    useEffect(() => {
        if (completato && sondaggio) {
            setMostraModalInviaSondaggio(false);
            const payload = buildSondaggioPartecipantePayload();

            // Controlla se il payload è stato creato correttamente
            if (payload) {
                console.log("Invio Payload:", JSON.stringify(payload, null, 2)); // Log per debug
                SondaggioPartecipanteService.saveSondaggioPartecipante(payload)
                    .then((res) => {
                        console.log("Risposte salvate con successo:", res.data);
                        // Potresti voler mostrare il punteggio all'utente nella pagina di ringraziamento
                        // setPunteggioOttenuto(payload.sonParPunteggioTotale); // Esempio se avessi uno stato per questo
                    })
                    .catch((err) => {
                        console.error("Errore nel salvataggio delle risposte:", err);
                        // Gestisci l'errore, magari mostrando un messaggio all'utente
                    });
            } else {
                console.error("Impossibile inviare le risposte: payload non valido.");
                // Gestisci l'errore (es. mostra messaggio all'utente)
            }
        }
    }, [completato, sondaggio, props.partecipante]); // Aggiungi dipendenze mancanti







    if (props.comune && props.comune.impostazioniComune && props.partecipante) {
        if (props.comune.impostazioniComune.imcModuloSondaggiAttivo) {
            if (props.partecipante.parId && props.partecipante.ruolo) {
                return (
                    <>
                        {/*possiblità con immagine del banner */}
                        {/*<div
  className="w-100 position-absolute"
  style={{
    minHeight: "30vh",
    zIndex: "-1",
    backgroundImage: `url(data:image/png;base64,${sondaggio?.sonBanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
/> */}
                        <div className="bg-secondary w-100 position-absolute" style={{ minHeight: "30vh", zIndex: "-1" }} />
                        <h1 className="title mt-4 text-center dark">Rispondi al sondaggio: {sondaggio?.sonTitolo}</h1>
                        <Card className="mx-md-5 mt-2 mb-5" style={{ minHeight: "90vh" }}>
                            <Card.Header>
                                <p className="mt-2 mb-0">Rispondi alle seguenti domande.</p>
                                <p className="italic text-muted">Le domande contrassegnate con un asterisco (*) sono obbligatorie.</p>
                            </Card.Header>

                            <Card.Body className="p-md-5 p-2">
                                {completato ? (
                                    <PaginaGrazie
                                        titolo="Grazie per averci detto la tua opinione!"
                                        sottotitolo="La tua partecipazione è fondamentale per migliorare i servizi della tua comunità.
          Il tuo contributo conta davvero!"
                                        bottone="Torna ai sondaggi"
                                        immagine={sondaggioCompletato}
                                    />
                                ) : (
                                    <>
                                        {/* Titolo del sondaggio */}

                                        {/* Nome sezione */}
                                        <h5 className="text-center mb-4 fw-bold text-dark">
                                            {sondaggio?.sezioni?.[sezioneCorrente]?.sezNome}
                                        </h5>
                                        {/* Domande */}
                                        {domandeCorrenti.map((domanda, index) => {
                                            const opzioni = [...domanda.opzioniRisposte].sort(
                                                (a, b) => a.opzRisPosizione - b.opzRisPosizione
                                            );

                                            const risposta = risposte[domanda.domId];

                                            const isMultipla = domanda.tipoDomanda?.tipDomMultipla;
                                            const isSingola = domanda.tipoDomanda?.tipDomSingola;

                                            return (
                                                <div
                                                    key={domanda.domId}
                                                    className={`mb-4 p-2 rounded ${domandeInErrore.includes(domanda.domId)
                                                        ? 'bg-danger bg-opacity-10 border border-danger transition'
                                                        : ''
                                                        }`}
                                                >

                                                    <div className="mb-1 fw-semibold fs-5">
                                                        {index + 1}. {domanda.domDomanda}
                                                        {domanda.domObbligatoria && <span className="text-danger"> *</span>}
                                                    </div>
                                                    <div className="d-flex flex-column gap-2">
                                                        {opzioni.map((opzione) => {
                                                            const isSelected = isSingola
                                                                ? risposta === opzione.opzRisId
                                                                : risposta?.includes(opzione.opzRisId);

                                                            return (
                                                                <label
                                                                    key={opzione.opzRisId}
                                                                    className="d-flex align-items-center gap-2 ps-2"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <input
                                                                        type={isSingola ? "radio" : "checkbox"}
                                                                        name={`domanda_${domanda.domId}`}
                                                                        value={opzione.opzRisId}
                                                                        checked={isSelected}
                                                                        onClick={(e) => {
                                                                            isSingola
                                                                                ? handleSingola(domanda.domId, opzione.opzRisId)
                                                                                : handleMultipla(
                                                                                    domanda,
                                                                                    opzione.opzRisId,
                                                                                    e.target.checked
                                                                                );
                                                                        }}
                                                                        className="form-check-input me-2"
                                                                        style={{ marginTop: "2px" }}
                                                                    />

                                                                    {opzione.opzRisTesto}
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {mostraErroreObbligatorie && (
                                            <div className="alert alert-danger text-center fw-semibold">
                                                Per favore, rispondi a tutte le domande obbligatorie.
                                            </div>
                                        )}
                                        {/* Pulsanti */}
                                        <div className="d-flex justify-content-between mt-4">
                                            <div>
                                                {sezioneCorrente > 0 ? (
                                                    <Button variant="secondary" onClick={handleIndietro}>
                                                        ← Indietro
                                                    </Button>
                                                ) : (
                                                    <Button variant="outline-danger" onClick={() => setMostraModalAbbandona(true)}>
                                                        Abbandona sondaggio
                                                    </Button>
                                                )}

                                            </div>

                                            <div>
                                                <Button variant="primary" onClick={handleInvia}>
                                                    Invia e continua →
                                                </Button>
                                            </div>
                                        </div>


                                    </>
                                )}
                            </Card.Body>

                        </Card>
                        <ModalConferma
                            mostra={mostraModalAbbandona}
                            setMostra={setMostraModalAbbandona}
                            mode="warning"
                            titolo="Sei sicuro di voler abbandonare il sondaggio?"
                            messaggio="Le risposte non saranno salvate e non potrai riprendere questo sondaggio."
                            bodyAlign="text-center"
                            btnAnnulla="No, resta qui"
                            btnConferma="Sì, abbandona"
                            azioneConferma={() => navigate(-1)}
                        />
                        <ModalConfermaConsensoPrivacy
                            mostra={mostraModalInviaSondaggio}
                            setMostra={setMostraModalInviaSondaggio}
                            setConsensoPrivacy={setConsensoPrivacy}
                            consensoPrivacy={consensoPrivacy}
                            comune={props.comune}
                            mode="info"
                            titolo="Inviare il sondaggio?"
                            messaggio="Una volta inviato, non sarà più possibile modificarlo. Sei sicuro di voler continuare?"
                            bodyAlign="text-center"
                            btnAnnulla="No, torna indietro"
                            btnConferma="Sì, invia"
                            azioneConferma={() => setCompletato(true)}
                        />

                    </>
                )

            } else {
                return (
                    <>
                        <div className="bg-secondary w-100 position-absolute" style={{ minHeight: "30vh", zIndex: "-1" }} />
                        <h1 className="title mt-4 text-center dark">Rispondi al sondaggio</h1>
                        <Card className="me-5 mt-2 ms-5 mb-5" style={{ minHeight: "90vh" }}>
                            <Card.Header></Card.Header>
                            <Card.Body className="p-5 text-center">
                                <h2>
                                    <FiAlertTriangle className="me-2 text-warning" />
                                    Attenzione
                                </h2>
                                <br />
                                Per procedere con la risposta al sondaggio devi prima effettuare il login!
                                <br /><br />
                                <Button variant="primary" onClick={goToLogin}>
                                    Accedi alla pagina di Login
                                </Button>
                            </Card.Body>
                        </Card>

                    </>
                )
            }

        } else {

            return (
                <>
                    <Navigate replace to="/pagina-non-trovata" />
                </>
            )

        }

    }



}